import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const LiveIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const svgColor = Colors24[color]
  return (
    <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.751011 6.05721C0.86932 3.8989 1.65197 2.02916 3.22335 0.50511C3.56311 0.174449 3.80883 0.171443 4.10611 0.46002C4.36093 0.706513 4.35487 0.986072 4.05454 1.31673C3.25672 2.18848 2.57721 3.13838 2.26778 4.28367C1.5822 6.81473 2.11307 9.08126 3.88467 11.0442C4.31846 11.5252 4.36397 11.8197 4.04848 12.0993C3.75422 12.3578 3.47817 12.2857 3.02617 11.8077C1.72175 10.431 0.951225 8.81373 0.811682 6.91693C0.799548 6.76663 0.766179 6.61934 0.754045 6.46904C0.744944 6.33076 0.754045 6.19549 0.754045 6.05721H0.751011Z"
        fill={svgColor}
        stroke={svgColor}
        strokeWidth="0.1"
      />
      <path
        d="M17.7516 6.0696C17.6878 8.48944 16.9082 10.3231 15.4248 11.8652C15.3217 11.9734 15.2064 12.0786 15.079 12.1568C14.8181 12.3161 14.5663 12.277 14.3691 12.0425C14.1841 11.8261 14.1689 11.5886 14.3479 11.3572C14.4329 11.249 14.5269 11.1437 14.6209 11.0476C16.9355 8.67881 17.342 4.30507 14.6664 1.53352C14.6149 1.47942 14.5633 1.4223 14.5178 1.36519C14.1689 0.944345 14.1538 0.724906 14.4571 0.463383C14.7332 0.222902 14.991 0.261981 15.3368 0.610678C16.435 1.71689 17.1721 3.0215 17.5028 4.53954C17.6332 5.13473 17.6969 5.74495 17.7485 6.0726L17.7516 6.0696Z"
        fill={svgColor}
        stroke={svgColor}
        strokeWidth="0.1"
      />
      <path
        d="M14.1051 6.32275C14.0596 7.63637 13.6349 8.8989 12.6581 9.95401C12.5549 10.0652 12.4457 10.1704 12.3274 10.2606C12.0058 10.5011 11.7541 10.4921 11.5174 10.2516C11.296 10.0262 11.293 9.67445 11.5447 9.41293C12.1363 8.79068 12.5792 8.09028 12.7551 7.24259C13.0676 5.73657 12.7309 4.39289 11.6904 3.23858C11.657 3.20251 11.6206 3.16643 11.5872 3.12736C11.299 2.79669 11.2808 2.45702 11.5356 2.22856C11.8026 1.99108 12.0665 2.01513 12.3972 2.33978C13.4801 3.40992 14.0687 4.6995 14.1051 6.32275Z"
        fill={svgColor}
        stroke={svgColor}
        strokeWidth="0.1"
      />
      <path
        d="M6.55939 10.5033C6.35311 10.359 6.17716 10.2598 6.03458 10.1306C4.05368 8.32996 3.83223 4.93317 5.56135 2.88608C5.7464 2.66664 5.94358 2.4502 6.16503 2.26684C6.44411 2.02936 6.7141 2.05341 6.93251 2.30291C7.15093 2.55241 7.19037 2.81393 6.93858 3.07245C6.25907 3.77886 5.81617 4.5995 5.66752 5.57646C5.45821 6.9502 5.8374 8.1496 6.71713 9.21072C6.82027 9.33698 6.97195 9.4482 7.01745 9.59249C7.07206 9.76383 7.10239 9.99529 7.02959 10.1426C6.95375 10.2959 6.73837 10.3801 6.56242 10.5093L6.55939 10.5033Z"
        fill={svgColor}
        stroke={svgColor}
        strokeWidth="0.1"
      />
      <path
        d="M9.21142 7.46312C8.56224 7.46312 8.0253 6.91302 8.02833 6.25471C8.0344 5.62645 8.57437 5.08837 9.21142 5.07635C9.83936 5.06433 10.4491 5.66252 10.4339 6.26974C10.4157 6.90401 9.84239 7.46312 9.20838 7.46312H9.21142Z"
        fill={svgColor}
        stroke={svgColor}
        strokeWidth="0.1"
      />
    </svg>
  )
}
